import { render, staticRenderFns } from "./vehicle-detail.vue?vue&type=template&id=c8549640&scoped=true&lang=pug&"
import script from "./vehicle-detail.vue?vue&type=script&lang=js&"
export * from "./vehicle-detail.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-detail.vue?vue&type=style&index=0&id=c8549640&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8549640",
  null
  
)

export default component.exports